import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { devtools } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'

// helpers
import { delayHttpRequest } from '../helpers/globalHelper'

// types
import {
  CachedBrandData,
  CachedHomeData,
  HomeData,
  firstDayInformation
} from '../types/homeTypes'
import { homeService } from '../services/homeService'
import { personalService } from '../services/personalService'
import { ProfileData } from '../types/personalTypes'
import { HomeCache } from '../types/globalTypes'

// types
type Store = {
  firsttimeData: firstDayInformation
  homeData: HomeData
  loading: boolean
  error: null
  toggleProfile: boolean
  corporation: any
  setToggleProfile: (profileShown: boolean) => void
  clearData: () => void
  fetchData: (id: number) => void
  fetchfirsttime: (id: number) => void
  PostfirstTime: (id: number) => void
  postlogDetails: (data: any) => any
  fetchcorporation: (EntityId: number, CorpId: number) => void
  fetchMaintenance: () => void
  maintenanceData: any
  fetchCompanyName: (essUserkey: number) => any
  companyData: any
  setLanguage: any
}

const useHomeStore = create(
  devtools<Store>((set) => ({
    homeData: null,
    loading: false,
    error: null,
    companyData: null,
    maintenanceData: null,
    firsttimeData: null,
    toggleProfile: true,
    corporation: null,
    setLanguage: (data: any) => {
      set((state) => ({ ...state, language: data }))
    },
    setToggleProfile: (profileShown) => {
      set((state) => ({ ...state, toggleProfile: profileShown }))
    },
    clearData: () =>
      set({ homeData: null, loading: false, error: null, toggleProfile: true }),

    fetchData: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _homeData = await homeService.fetchData(id)

        set((state) => ({ ...state, homeData: _homeData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchfirsttime: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _homeData = await homeService.fetchfirsttime(id)

        set((state) => ({ ...state, firsttimeData: _homeData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    PostfirstTime: async (id) => {
      set((state) => ({ ...state, loading: true }))
      try {
        const _Data = await homeService.PostfirstTime(id)
        set((state) => ({ ...state, postData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    postlogDetails: async (data) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()

        return await homeService.postlogDetails(data)
      } catch (error) {
        set((state) => ({ ...state, error: error.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchcorporation: async (EntityId, CorpId) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const corporation = await homeService.fetchcorporation(EntityId, CorpId)

        set((state) => ({ ...state, corporation: corporation }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchMaintenance: async () => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _maintenace = await homeService.fetchMaintenance()

        set((state) => ({ ...state, maintenanceData: _maintenace }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchCompanyName: async (essUserkey: number) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _companyData = await homeService.fetchCompanyName(essUserkey)
        set((state) => ({ ...state, companyData: _companyData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)

export { useHomeStore }
